import { Project, UploadScenarioProject, energyProjectTypes, forecastDetachedHouseProjectTypes, transmissionProjectTypes } from "../../components/scenario-modelling/TableData"

export function getProjectTypes(priorYearProjectList: any) {
    return priorYearProjectList?.executeGetRawProjectTypes?.map((type) => {
        return type.RawProjectType
    }
    ) ?? []
}

export function getLocations(priorYearProjectList: any) {
    return priorYearProjectList?.executeGetLocationList?.map((location) => {
        return { state: location.State, locationName: location.LocationName }
    }
    ) ?? []
}

export function getStates(priorYearProjectList: any) {
    return priorYearProjectList?.executeGetState.map((location) => {
        return location.State
    }
    ) ?? []
}

export function getSource(priorYearProjectList: any) {
    return priorYearProjectList?.executeGetSourceList.map((source) => {
        return source.Source
    }
    ) ?? []
}

export function getProjectLatestStatus(statusList: any) {
    return statusList?.map((status) => {
        return status.value
    })
}

export function getFundingMode(fundingList: any) {
    return fundingList?.map((funding) => {
        return funding.value
    })
}

export function getSortedLocationByState(locations: any, states: any) {
    // Group locations by state
    const locationsByState = {};
    locations.forEach(({ locationName, state }) => {
        if (!locationsByState[state]) {
            locationsByState[state] = [];
        }
        locationsByState[state].push(locationName);
    });

    // Sort and filter states
    const sortedLocationsByState = states.reduce((acc, state) => {
        if (locationsByState[state]) {
            acc[state] = locationsByState[state];
        }
        return acc;
    }, {});

    return sortedLocationsByState;
}

// Get forecast and ongoing based on processingPath
export function getForecast(processingPath) {
    if (([3, 4, 5].indexOf(processingPath) > -1))
        return "yes"
    else
        return "no"
}

export function getOngoing(processingPath) {
    if (([7].indexOf(processingPath) > -1))
        return "yes"
    else
        return "no"
}

export const calculateProcessingPath = (forecast: string, ongoing: string, values: Project | UploadScenarioProject): number => {

    // default path
    if (forecast == "no" && ongoing == "no") {
        // processing path 1
        if ([...transmissionProjectTypes, ...energyProjectTypes].indexOf(values.RawProjectType) === -1) {
            return 1;

        }

        // processing 2
        if (energyProjectTypes.indexOf(values.RawProjectType) > -1) {
            return 2
        }

    }
    if (forecast == "yes" && [...transmissionProjectTypes, ...energyProjectTypes, ...forecastDetachedHouseProjectTypes].indexOf(values.RawProjectType) > -1) {
        // processing path 3
        if (energyProjectTypes.indexOf(values.RawProjectType) > -1) {
            return 3;
        }
        // processing path 4
        if ([transmissionProjectTypes[1],
        transmissionProjectTypes[2]].indexOf(values.RawProjectType) > -1 || forecastDetachedHouseProjectTypes.indexOf(values.RawProjectType) > -1) {
            return 4;
        }
        //processing path 5
        if ([transmissionProjectTypes[0]].indexOf(values.RawProjectType) > -1) {
            return 5;
        }

    }
    //processing path 7
    if (forecast === "no" && ongoing == "yes" && [...transmissionProjectTypes, ...energyProjectTypes].indexOf(values.RawProjectType) === -1) {
        return 7;
    }

    return 1;
}